"use strict";
const $ = window.$;

$(document).ready(function() {
  $(".js-share-button-popup").on("click", function() {
    window.open(this.href, this.target, "width=550,height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1");
    return false;
  });
});
